<template>
  <div>
    <div class="row">
      <div v-for="(data, id) in datas" :key="id" class="col-12">
        <div class="card card_grey mb_12">
          <div class="sub_title_2 m-b-20">
            {{ data.metricName }}
          </div>
          <div class="m-b-20 d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <div class="data_text">
                {{ convertCurrency(data.value) }} {{ data.unit }}
              </div>
              <div class="d-flex ms-2">
                <div
                  class="d-inline-flex align-items-center"
                  :class="
                    data.achievementStatus == 'UP' ? 'badge_green' : 'badge_red'
                  "
                >
                  <IconSvg
                    :color="data.achievementStatus == 'UP' ? 'green' : 'red'"
                    :type="
                      data.achievementStatus == 'UP' ? 'chart_up' : 'chart_down'
                    "
                  />
                  <div
                    class="data_detil"
                    :class="
                      data.achievementStatus == 'UP' ? 'text_green' : 'text_red'
                    "
                  >
                    <span v-if="data.achievementStatus == 'UP'">+</span
                    >{{ data.achievement }}%
                  </div>
                </div>
                <div
                  class="d-inline-flex align-items-center me-2"
                  :class="
                    data.trendStatus == 'UP' ? 'badge_green' : 'badge_red'
                  "
                >
                  <IconSvg
                    :color="data.trendStatus == 'UP' ? 'green' : 'red'"
                    :type="data.trendStatus == 'UP' ? 'arrow_up' : 'arrow_down'"
                  />
                  <div
                    class="data_detil"
                    :class="
                      data.trendStatus == 'UP' ? 'text_green' : 'text_red'
                    "
                  >
                    <span v-if="data.trendStatus == 'UP'">+</span
                    >{{ data.trend }}%
                  </div>
                </div>
              </div>
            </div>
            <div>
              <button class="naked_button" @click="onShowModalGeneral(data)">
                <img src="@/assets/images/a/chart_icon.svg" />
              </button>
            </div>
          </div>
          <div class="data_revenue mt-1">
            {{ data.general_revenue }}% of Revenue
          </div>
        </div>
      </div>
      <!-- <div class="col-12">
        <div class="card card_grey mb_12">
          <div class="sub_title_2 m-b-20">
            Revenue from land and building utilization (IDR)
          </div>
          <div class="m-b-20 d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <div class="data_text">{{ convertCurrency(data.revenue_value) }} Bn</div>
              <div class="d-flex ms-2">
                <div class="d-inline-flex align-items-center me-2" :class="data.revenue_trend_status == 'UP' ? 'badge_green' : 'badge_red'">
                  <IconSvg :color="data.revenue_trend_status == 'UP' ? 'green' : 'red'" :type="data.revenue_trend_status == 'UP' ? 'arrow_up' : 'arrow_down'" />
                  <div class="data_detil" :class="data.revenue_trend_status == 'UP' ? 'text_green' : 'text_red'">
                    <span v-if="data.revenue_trend_status == 'UP'">+</span>{{ data.revenue_trend }}%
                  </div>
                </div>
                <div class="d-inline-flex align-items-center" :class="data.revenue_achievement_status == 'UP' ? 'badge_green' : 'badge_red'">
                  <IconSvg :color="data.revenue_achievement_status == 'UP' ? 'green' : 'red'" :type="data.revenue_achievement_status == 'UP' ? 'chart_up' : 'chart_down'" />
                  <div class="data_detil" :class="data.revenue_achievement_status == 'UP' ? 'text_green' : 'text_red'">
                    <span v-if="data.revenue_achievement_status == 'UP'">+</span>{{ data.revenue_achievement }}%
                  </div>
                </div>
              </div>
            </div>
            <div>
              <button class="naked_button" @click="onShowModalRevenue()">
                <img src="@/assets/images/a/chart_icon.svg" />
              </button>
            </div>
          </div>
          <div class="data_revenue mt-1">
            {{ data.revenue_revenue }}% of Revenue
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import IconSvg from "@/components/IconSvg.vue";
import { currencyFormatNumberComma } from "@/utils/helper";

export default {
  props: ["load", "datas"],
  components: {
    IconSvg,
  },

  data() {
    return {
      modalRevenue: {
        show: false,
        load: false,
      },
      modalGeneral: {
        show: false,
        load: false,
      },
    };
  },

  methods: {
    // async getDataGeneral() {
    //   const res = await this.apiLegal.getDataGeneral
    // },
    convertCurrency(x) {
      const str = x.toString();
      if (str.includes(".")) {
        const cnv = str.split(".")[0];
        let dotIndex = str.indexOf(".");
        const after = str.slice(dotIndex + 1);
        return currencyFormatNumberComma(cnv) + "." + after;
      } else {
        return currencyFormatNumberComma(str);
      }
    },
    onShowModalRevenue() {
      this.modalRevenue.show = true;
    },
    onCloseModalRevenue(value) {
      this.modalRevenue.show = value;
    },

    onShowModalGeneral(x) {
      if (x.metricId.includes("REVENUE")) {
        this.modalRevenue.show = true;
      } else {
        this.modalGeneral.show = true;
      }
    },
    onCloseModalGeneral(value) {
      this.modalGeneral.show = value;
    },
  },
};
</script>
